import './cta.style.css'
import { cvPath } from '../../utils/config'
const Cta = () => {
  return (
    <div>
      <div className="cta">
        <a className="btn pad" href={cvPath} download>
          Download CV
        </a>
        <a className="btn btn-primary pad" href="#contact">
          Let's talk
        </a>
      </div>
    </div>
  )
}

export default Cta
